import * as actionTypes from "./actionTypes";

const initialState = {
  reprocessDataLoading: false,
  reprocessDataSuccess: false,
  deleteUserScreenshotsLoading: false,
  deleteUserScreenshotsSuccess: false,
  sendEmailReportLoading: false,
  sendEmailReportSuccess: false,
  maintenanceErrorMessage: "",
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    // please fill the rest
    case actionTypes.REPROCESS_DATA:
      return {
        ...state,
        reprocessDataLoading: action.payload,
        reprocessDataSuccess: false,
        maintenanceErrorMessage: "",
      };

    case actionTypes.REPROCESS_DATA_SUCCESS:
      return {
        ...state,
        reprocessDataLoading: false,
        reprocessDataSuccess: true,
        maintenanceErrorMessage: "",
      };

    case actionTypes.REPROCESS_DATA_FAILED:
      return {
        ...state,
        reprocessDataLoading: false,
        maintenanceErrorMessage: action.payload,
      };

    case actionTypes.DELETE_USER_SCREENSHOTS:
      return {
        ...state,
        deleteUserScreenshotsLoading: action.payload,
        deleteUserScreenshotsSuccess: false,
        maintenanceErrorMessage: "",
      };

    case actionTypes.DELETE_USER_SCREENSHOTS_SUCCESS:
      return {
        ...state,
        deleteUserScreenshotsLoading: false,
        deleteUserScreenshotsSuccess: true,
        maintenanceErrorMessage: "",
      };

    case actionTypes.DELETE_USER_SCREENSHOTS_FAILED:
      return {
        ...state,
        deleteUserScreenshotsLoading: false,
        deleteUserScreenshotsSuccess: false,
        maintenanceErrorMessage: action.payload,
      };

      case actionTypes.SEND_EMAIL_REPORT:
      return {
        ...state,
        sendEmailReportLoading: true,
        sendEmailReportSuccess: false,
        maintenanceErrorMessage: "",
      };

    case actionTypes.SEND_EMAIL_REPORT_SUCCESS:
      return {
        ...state,
        sendEmailReportLoading: false,
        sendEmailReportSuccess: true,
        maintenanceErrorMessage: "",
      };

    case actionTypes.SEND_EMAIL_REPORT_FAILED:
      return {
        ...state,
        sendEmailReportLoading: false,
        sendEmailReportSuccess: false,
        maintenanceErrorMessage: action.payload,
      };

    case actionTypes.RESET_MAINTENANCE_STUFF:
      return {
        ...state,
        maintenanceErrorMessage: action.payload,
        reprocessDataSuccess: false,
        sendEmailReportSuccess: false,
      };

    default:
      return state;
  }
};
